export class CurrencyUtil {
  public static convert(amount: number): number {
    return amount / 100;
  }
}
